import { render, staticRenderFns } from "./WebhooksConfiguracaoRow.vue?vue&type=template&id=7ddd3c58&"
import script from "./WebhooksConfiguracaoRow.vue?vue&type=script&lang=js&"
export * from "./WebhooksConfiguracaoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports